import { formatNumber } from "@wrstudios/utils";
import PropTypes from "prop-types";
import React from "react";
import {
  Bar,
  Bars,
  BarsContainer,
  ChartLine,
  ChartLineLabel,
  ChartLines,
  Container,
  Label,
  LabelColor,
  Labels,
  MobileLabels
} from "./styled/live-rdc-horizontal-bar-chart";

function LiveRdcHorizontalBarChart({
  zipCode,
  totalValue,
  primaryValue: _primaryValue,
  secondaryValue: _secondaryValue
}) {
  const primaryValue = Math.min(_primaryValue, totalValue);
  const secondaryValue = Math.min(_secondaryValue, totalValue);
  const steps = 6;
  const stepAmount = totalValue / steps;
  const primaryBarPercentage = (primaryValue / totalValue) * 100;
  const secondaryBarPercentage = (secondaryValue / totalValue) * 100;

  return (
    <div>
      <Container>
        <Labels>
          <Label>In your zip code ({zipCode})</Label>
          <Label>In 10 nearby zip codes</Label>
        </Labels>
        <BarsContainer>
          <Bars>
            <Bar
              style={{
                width:
                  primaryBarPercentage > 0
                    ? `${primaryBarPercentage}%`
                    : "19.2rem"
              }}>
              {primaryValue}
            </Bar>
            <Bar
              style={{
                width:
                  secondaryBarPercentage > 0
                    ? `${secondaryBarPercentage}%`
                    : "2rem"
              }}
              secondary>
              {secondaryValue}
            </Bar>
          </Bars>
          <ChartLines>
            {Array.from({ length: steps }, (_, index) => (
              <ChartLine key={index}>
                {index === 0 ? (
                  <>
                    <ChartLineLabel>
                      {formatNumber(stepAmount * index, "0")}
                    </ChartLineLabel>
                    <ChartLineLabel>
                      {formatNumber(stepAmount * (index + 1), "0")}
                    </ChartLineLabel>
                  </>
                ) : (
                  <>
                    <div />
                    <ChartLineLabel>
                      {formatNumber(stepAmount * (index + 1), "0")}
                    </ChartLineLabel>
                  </>
                )}
              </ChartLine>
            ))}
          </ChartLines>
        </BarsContainer>
      </Container>
      <MobileLabels>
        <div>
          <Label>
            <LabelColor />
            In your zip code ({zipCode})
          </Label>
          <Label>
            <LabelColor secondary />
            In 10 nearby zip codes
          </Label>
        </div>
      </MobileLabels>
    </div>
  );
}

LiveRdcHorizontalBarChart.propTypes = {
  zipCode: PropTypes.string.isRequired,
  totalValue: PropTypes.number.isRequired,
  primaryValue: PropTypes.number.isRequired,
  secondaryValue: PropTypes.number.isRequired
};

export default LiveRdcHorizontalBarChart;
